import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { LanguageProvider } from './contexts/LanguageContext';

// Public Pages
import Homepage from './pages/Homepage';
import About from './pages/About';
import Pricing from './pages/Pricing';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Waitlist from './pages/Waitlist';
import HowItWorksCandidates from './pages/HowItWorksCandidates';
import HowItWorksEmployers from './pages/HowItWorksEmployers';
import JoinTalentPool from './pages/JoinTalentPool';

// Auth Pages
import Login from './pages/Login';
import RegisterCandidate from './pages/RegisterCandidate';
import RegisterEmployer from './pages/RegisterEmployer';

// Candidate Pages
import CandidateDashboard from './pages/candidate/CandidateDashboard';
import UploadCV from './pages/candidate/UploadCV';
import VideoInterview from './pages/candidate/VideoInterview';
import JobMatches from './pages/candidate/JobMatches';
import RelocationChecklist from './pages/candidate/RelocationChecklist';
import VerificationModule from './pages/candidate/VerificationModule';

// Employer Pages
import EmployerDashboard from './pages/employer/EmployerDashboard';
import PostJob from './pages/employer/PostJob';
import CandidateMatches from './pages/employer/CandidateMatches';
import Analytics from './pages/employer/Analytics';
import EmployerTalentPool from './pages/employer/TalentPool';

// Feature Pages
import MedicallyLedAdvantage from './pages/MedicallyLedAdvantage';
import Onboarding from './pages/Onboarding';
import EnhancedDashboard from './pages/candidate/EnhancedDashboard';

// Legal Pages
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsOfService from './pages/legal/TermsOfService';
import GDPRCompliance from './pages/legal/GDPRCompliance';
import AITransparency from './pages/legal/AITransparency';

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/waitlist" element={<Waitlist />} />
          <Route path="/join-talent-pool" element={<JoinTalentPool />} />
          <Route path="/how-it-works/candidates" element={<HowItWorksCandidates />} />
          <Route path="/how-it-works/employers" element={<HowItWorksEmployers />} />
          
          {/* Legal Routes */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/gdpr" element={<GDPRCompliance />} />
          <Route path="/ai-transparency" element={<AITransparency />} />
          
          {/* Auth Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register/candidate" element={<RegisterCandidate />} />
          <Route path="/register/employer" element={<RegisterEmployer />} />
          
          {/* Candidate Routes */}
          <Route path="/candidate/dashboard" element={<CandidateDashboard />} />
          <Route path="/candidate/upload-cv" element={<UploadCV />} />
          <Route path="/candidate/documents" element={<UploadCV />} />
          <Route path="/candidate/video-interview" element={<VideoInterview />} />
          <Route path="/candidate/job-matches" element={<JobMatches />} />
          <Route path="/candidate/relocation" element={<RelocationChecklist />} />
          <Route path="/candidate/verification" element={<VerificationModule />} />
          
          {/* Employer Routes */}
          <Route path="/employer/dashboard" element={<EmployerDashboard />} />
          <Route path="/employer/post-job" element={<PostJob />} />
          <Route path="/employer/candidates" element={<CandidateMatches />} />
          <Route path="/employer/talent-pool" element={<EmployerTalentPool />} />
          <Route path="/employer/analytics" element={<Analytics />} />
          
          {/* Feature Pages */}
          <Route path="/medically-led-advantage" element={<MedicallyLedAdvantage />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/candidate/enhanced-dashboard" element={<EnhancedDashboard />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/talent-pool" element={<AdminDashboard />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  </LanguageProvider>
  );
}

export default App;